interface Props {
    className?: string
    FillColor?: string
}

export default function Star({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" className={className}>
            <path
                d="M11.2961 2.22888C11.5786 1.63675 12.4215 1.63677 12.704 2.22888L15.5258 8.14237L22.0218 8.99867C22.6723 9.08441 22.9327 9.886 22.4569 10.3377L17.7048 14.8487L18.8978 21.2914C19.0173 21.9365 18.3354 22.4319 17.7588 22.119L12.0001 18.9935L6.24133 22.119C5.6647 22.4319 4.98285 21.9365 5.1023 21.2914L6.2953 14.8487L1.54321 10.3377C1.06738 9.88599 1.32784 9.08441 1.97828 8.99867L8.47432 8.14237L11.2961 2.22888ZM12.0001 4.23665L9.6598 9.14104C9.5461 9.37933 9.31956 9.54393 9.05778 9.57843L3.67025 10.2886L7.61142 14.0299C7.80291 14.2116 7.88945 14.478 7.84137 14.7376L6.85195 20.0809L11.628 17.4887C11.86 17.3628 12.1401 17.3628 12.3721 17.4887L17.1482 20.0809L16.1587 14.7376C16.1107 14.478 16.1972 14.2117 16.3887 14.0299L20.3299 10.2886L14.9423 9.57843C14.6806 9.54393 14.454 9.37934 14.3403 9.14104L12.0001 4.23665Z"
                fill={FillColor}/>
        </svg>
    )
}
